import { fetchAddress } from '../../../helpers/utils';

// for handleUpdateBooking()
export const getForwardersAndGeoCodes = ({
  forwarderList,
  origin,
  destination,
}) => {
  const forwarders = [];
  if (forwarderList?.length > 0) {
    forwarderList?.forEach((itm) => {
      if (itm.value !== '') {
        forwarders.push(itm.value);
      }
    });
  }
  let originGeoCode;
  let destinationGeoCode;

  if (origin?.originGeoCode?.length > 0) {
    let lat;
    let long;
    if (origin?.originGeoCode[0].GeoCoordinate !== 'NULL') {
      [lat, long] = origin.originGeoCode[0].GeoCoordinate.split(',');
    } else {
      lat = 'NULL';
      long = '';
    }
    originGeoCode = { lat: lat.trim(), long: long.trim() };
  }
  if (destination?.destinationGeoCode?.length > 0) {
    let lat;
    let long;
    if (destination?.destinationGeoCode[0].GeoCoordinate !== 'NULL') {
      [lat, long] = destination.destinationGeoCode[0].GeoCoordinate.split(',');
    } else {
      lat = 'NULL';
      long = '';
    }
    destinationGeoCode = { lat: lat.trim(), long: long.trim() };
  }
  return { forwarders, originGeoCode, destinationGeoCode };
};

export const getAddress = ({ type, originData, destinationData }) => {
  return {
    type,
    portName:
      type === 'origin' ? originData?.origin : destinationData?.destination,
    street:
      fetchAddress(
        type,
        'neighborhood',
        [],
        destinationData?.destinationDoorAddress,
        originData?.originDoorAddress
      ) ||
      fetchAddress(
        type,
        'route',
        [],
        destinationData?.destinationDoorAddress,
        originData?.originDoorAddress
      ),
    city:
      fetchAddress(
        type,
        'administrative_area_level_2',
        [],
        destinationData?.destinationDoorAddress,
        originData?.originDoorAddress
      ) ||
      fetchAddress(
        type,
        'locality',
        [],
        destinationData?.destinationDoorAddress,
        originData?.originDoorAddress
      ),
    state: fetchAddress(
      type,
      'administrative_area_level_1',
      [],
      destinationData?.destinationDoorAddress,
      originData?.originDoorAddress
    ),
    country:
      fetchAddress(
        type,
        'country',
        [],
        destinationData?.destinationDoorAddress,
        originData?.originDoorAddress
      ) || originData?.originCountry,
    zipcode: fetchAddress(
      type,
      'postal_code',
      [],
      destinationData?.destinationDoorAddress,
      originData?.originDoorAddress
    ),
  };
};

// since we now have new address format for inland
export const getNewAddress = ({ type, address }) => {
  return {
    type,
    portName: address?.formatted_address || '',
    street: address?.street?.name || '',
    city: address?.city?.name || '',
    state: address?.state?.name || '',
    country: address?.country?.name || '',
    zipcode: address?.zipCode?.name || '',
    geoCode: {
      lat: address?.latitude?.toString() || '',
      long: address?.longitude?.toString() || '',
    },
  };
};

// for useEffect with dependency -> [bookingInfo, bookingList]
export const defaultOriginValue = (data) => {
  return {
    origin: (data?.originFacility !== '-' && data?.originFacility) || '',
    originGeoCode:
      data?.originGeoCode !== null
        ? [
            {
              GeoCoordinate: `${
                data?.originGeoCode?.lat !== 'NULL' &&
                data?.originGeoCode?.lat !== undefined &&
                data?.originGeoCode?.long !== undefined &&
                data?.originGeoCode?.lat &&
                data?.originGeoCode?.long
                  ? `${data.originGeoCode?.lat}, ${data.originGeoCode?.long}`
                  : 'NULL'
              }`,
            },
          ]
        : [],
    originDoorAddress: [],
    originCountry:
      data?.address !== null
        ? data?.address?.filter((itm) => itm?.type === 'origin')?.[0]
            ?.country || ''
        : '',
  };
};

export const defaultDestinationValues = (data) => {
  return {
    destinationCountry:
      data?.address !== null
        ? data?.address?.filter((itm) => itm?.type === 'destination')?.[0]
            ?.country || ''
        : '',
    destinationDoorAddress: [],
    destinationGeoCode:
      data?.destinationGeoCode !== null
        ? [
            {
              GeoCoordinate: `${
                data?.destinationGeoCode?.lat !== 'NULL' &&
                data?.destinationGeoCode?.lat !== undefined &&
                data?.destinationGeoCode?.long !== undefined &&
                data?.destinationGeoCode?.lat &&
                data?.destinationGeoCode?.long
                  ? `${data?.destinationGeoCode?.lat.trim()}, ${data?.destinationGeoCode?.long.trim()}`
                  : 'NULL'
              }`,
            },
          ]
        : [],
    destination:
      data?.destinationFacility !== '-' ? data?.destinationFacility : '' || '',
  };
};

export const defaultDeliveryValues = (data) => {
  return {
    destinationCountry: data?.country ? data?.country : '',
    destinationDoorAddress: [],
    destinationGeoCode:
      data?.geoCode !== null
        ? [
            {
              GeoCoordinate: `${
                data?.geoCode?.lat !== 'NULL' &&
                data?.geoCode?.lat !== undefined &&
                data?.geoCode?.long !== undefined &&
                data?.geoCode?.lat &&
                data?.geoCode?.long
                  ? `${data?.geoCode?.lat.trim()}, ${data?.geoCode?.long.trim()}`
                  : 'NULL'
              }`,
            },
          ]
        : [],
    destination: data?.portName || '',
  };
};

export const defaultPickUpValues = (data) => {
  return {
    origin: data?.portName || '',
    originGeoCode:
      data?.geoCode !== null
        ? [
            {
              GeoCoordinate: `${
                data?.geoCode?.lat !== 'NULL' &&
                data?.geoCode?.lat !== undefined &&
                data?.geoCode?.long !== undefined &&
                data?.geoCode?.lat &&
                data?.geoCode?.long
                  ? `${data?.geoCode?.lat.trim()}, ${data?.geoCode?.long.trim()}`
                  : 'NULL'
              }`,
            },
          ]
        : [],
    originDoorAddress: [],
    originCountry: data?.country ? data?.country : '',
  };
};

export const getBookingValue = (bookingInfo, isConsoliatedBooking) => {
  return {
    mode:
      bookingInfo?.mode || isConsoliatedBooking
        ? {
            label:
              bookingInfo.mode === 'Inland' || isConsoliatedBooking
                ? 'Road'
                : bookingInfo.mode,
            value: isConsoliatedBooking ? 'Inland' : bookingInfo.mode,
          }
        : {},
    containerType: bookingInfo?.containerType
      ? {
          label: bookingInfo.containerType,
          value: bookingInfo.containerType,
        }
      : {},
    cargoLoad: bookingInfo?.cargoLoad
      ? {
          label: bookingInfo.cargoLoad,
          value: bookingInfo.cargoLoad,
        }
      : {},
    equipmentType: bookingInfo?.equipmentType
      ? {
          label: bookingInfo.equipmentType,
          value: bookingInfo.equipmentType,
        }
      : {},
    equipTypeQty: bookingInfo?.equipTypeQty || 1,
    typeOfMove: bookingInfo?.typeofMove
      ? {
          label: bookingInfo.typeofMove
            .replaceAll('port', 'Port')
            .replaceAll('door', 'Door'),
          value: bookingInfo.typeofMove,
        }
      : {},
    incoTerm:
      bookingInfo?.incoTerm || bookingInfo?.defaultIncoTerm
        ? {
            label: bookingInfo?.incoTerm || bookingInfo?.defaultIncoTerm,
            value: bookingInfo?.incoTerm || bookingInfo?.defaultIncoTerm,
          }
        : {},
    numberOfTrucks: bookingInfo?.numberOfTrucks || 1,
    totalWeight: bookingInfo?.totalWeight || null,
    originLocation: bookingInfo?.originLocation,
    destinationLocation: bookingInfo?.destinationLocation,
    shipmentType: bookingInfo?.shipmentType
      ? {
          label: bookingInfo.shipmentType,
          value: bookingInfo.shipmentType,
        }
      : {},
    weightUnit: bookingInfo?.weightUnit
      ? { label: bookingInfo?.weightUnit, value: bookingInfo?.weightUnit }
      : { label: 'Kgs', value: 'Kgs' },
  };
};

export const findDefaultDeliveryAddress = (bookingList) => {
  let defaultDeliveryAddress = {};
  bookingList?.forEach((obj) => {
    if (
      (obj?.bookingType === 'Delivery' &&
        obj?.deliveryAddress?.type === 'destination') ||
      (obj?.bookingType === 'Primary' &&
        obj?.bookHandle?.delivery &&
        obj?.deliveryAddress?.type === 'destination')
    ) {
      defaultDeliveryAddress = obj?.deliveryAddress;
    }
  });
  return defaultDeliveryAddress;
};

export const findDefaultPickUpAddress = (bookingList) => {
  let defaultPickUpAddress = {};
  bookingList?.forEach((obj) => {
    if (
      (obj?.bookingType === 'Pickup' &&
        obj?.pickupAddress?.type === 'origin') ||
      (obj?.bookingType === 'Primary' &&
        obj?.bookHandle?.pickup &&
        obj?.pickupAddress?.type === 'origin')
    ) {
      defaultPickUpAddress = obj?.pickupAddress;
    }
  });
  return defaultPickUpAddress;
};

export const findNotifyPartyAndConsignee = (bookingInfo) => {
  let notifyParty = '';
  let consigneeDetail = '';
  bookingInfo?.entities?.forEach((item) => {
    if (item?.type === 'notify party') notifyParty = item?.name;
    if (item?.type === 'consignee') consigneeDetail = item?.name;
  });
  return { notifyParty, consigneeDetail };
};

export const getPartiallyBooked = (bookingInfo, bookingList, profileType) => {
  // check bookingInfo?.bookAction?.pickup = false at buyer i.e direct to supplier or use pickupswitchto
  return profileType === 'buyer'
    ? !!bookingList?.length ||
        bookingInfo?.directedBooking?.primary ||
        bookingInfo?.directedBooking?.pickup ||
        bookingInfo?.directedBooking?.delivery
    : bookingInfo?.bookAction?.primary ||
        bookingInfo?.bookAction?.pickup ||
        bookingInfo?.bookAction?.delivery;
};

// for useEffect with dependency -> [
//     bookingInfo?.bookAction?.primary,
//     bookingInfo?.bookAction?.pickup,
//     bookingInfo?.bookAction?.delivery,
//     primaryBookingCompleted,
//     pickupBookingCompleted,
//     deliveryBookingCompleted,
//   ]

export const handlePrimaryPickupDeliveryBooking = (
  primaryBookingCompleted,
  pickupBookingCompleted,
  deliveryBookingCompleted,
  setStates
) => {
  if (
    !primaryBookingCompleted &&
    !pickupBookingCompleted &&
    !deliveryBookingCompleted
  ) {
    setStates('primary', true, true);
  } else if (
    primaryBookingCompleted &&
    !pickupBookingCompleted &&
    !deliveryBookingCompleted
  ) {
    setStates('pickUp', false, false);
  } else if (
    primaryBookingCompleted &&
    pickupBookingCompleted &&
    !deliveryBookingCompleted
  ) {
    setStates('delivery', false, false);
  } else if (
    primaryBookingCompleted &&
    !pickupBookingCompleted &&
    deliveryBookingCompleted
  ) {
    setStates('pickUp', false, false);
  } else if (
    !primaryBookingCompleted &&
    pickupBookingCompleted &&
    !deliveryBookingCompleted
  ) {
    setStates('primary', false, true);
  } else if (
    !primaryBookingCompleted &&
    !pickupBookingCompleted &&
    deliveryBookingCompleted
  ) {
    setStates('primary', true, false);
  } else if (
    !primaryBookingCompleted &&
    pickupBookingCompleted &&
    deliveryBookingCompleted
  ) {
    setStates('primary', false, false);
  }
};

export const handlePrimaryPickup = (
  primaryBookingCompleted,
  pickupBookingCompleted,
  setStates
) => {
  if (!primaryBookingCompleted && !pickupBookingCompleted) {
    setStates('primary', true, false);
  } else if (primaryBookingCompleted && !pickupBookingCompleted) {
    setStates('pickUp', false, false);
  } else if (!primaryBookingCompleted && pickupBookingCompleted) {
    setStates('primary', false, false);
  }
  // need to check about (primaryBookingCompleted && pickupBookingCompleted)
};

export const handlePrimaryDelivery = (
  primaryBookingCompleted,
  deliveryBookingCompleted,
  setStates
) => {
  if (!primaryBookingCompleted && !deliveryBookingCompleted) {
    setStates('primary', false, true);
  } else if (primaryBookingCompleted && !deliveryBookingCompleted) {
    setStates('delivery', false, false);
  } else if (!primaryBookingCompleted && deliveryBookingCompleted) {
    setStates('primary', false, false);
  }
  // need to check about (primaryBookingCompleted && deliveryBookingCompleted)
};

export const handleDeliveryPickup = (
  pickupBookingCompleted,
  deliveryBookingCompleted,
  setStates
) => {
  if (!pickupBookingCompleted && !deliveryBookingCompleted) {
    setStates('pickUp', false, false);
  } else if (pickupBookingCompleted && !deliveryBookingCompleted) {
    setStates('delivery', false, false);
  } else if (!pickupBookingCompleted && deliveryBookingCompleted) {
    setStates('pickUp', false, false);
  }
};

export const handleSingleBookingType = (type, setStates) => {
  if (type === 'primary') {
    setStates('primary', false, false);
  } else if (type === 'pickUp') {
    setStates('pickUp', false, false);
  } else if (type === 'delivery') {
    setStates('delivery', false, false);
  }
};

// for 2 new tabs
export const getBach = (product, field) => {
  if (field === 'grossWeight') {
    if (product?.measurementUnit === 'imperial') return 'Lbs';
    return 'Kgs';
  }
  if (field === 'quantity') {
    return '';
  }
  if (product?.measurementUnit === 'imperial') return 'In';
  if (product?.measurementUnit === 'metric') return 'Cm';
  return '';
};

export const handlePrdPkgChange = (e, id, setProducts) => {
  const { name, value, checked } = e.target;
  setProducts((prev) =>
    prev?.map((product) => {
      if (product?.id !== id) {
        return product;
      }
      const updatedProduct = { ...product };
      if (name === 'measurementUnit') {
        updatedProduct[name] = checked ? 'imperial' : 'metric';
      }
      //  else if (name === 'hazmat' || name === 'customClearance') {
      //   updatedProduct[name] = checked;
      // }
      else if (name === 'selectedProductIds') {
        if (
          e.target.checked &&
          e?.target?.productId &&
          !updatedProduct[name]?.includes(e?.target?.productId)
        ) {
          updatedProduct[name]?.push(e?.target?.productId);
        }
        if (
          !e.target.checked &&
          e?.target?.productId &&
          updatedProduct[name]?.includes(e?.target?.productId)
        ) {
          updatedProduct[name] = updatedProduct[name]?.filter(
            (productId) => productId !== e?.target?.productId
          );
        }
      } else if (name === 'name') {
        // Enforce alphanumeric validation and 10-character limit
        const alphanumericRegex = /^[a-zA-Z0-9\s]*$/;
        if (!alphanumericRegex.test(value)) {
          return product; // Ignore invalid input
        }
        updatedProduct[name] = value.slice(0, 50); // Limit to 50 characters
      } else {
        updatedProduct[name] = value;
      }
      return updatedProduct;
    })
  );
};

export const isGrossWtInvalid = (pkg, products) => {
  const { selectedProductIds, grossWeight, measurementUnit: pkgUnit } = pkg;
  if (!selectedProductIds?.length) return false;

  const KgsToLbs = 2.20462;
  const LbsToKgs = 0.453592;

  let grossWtSum = 0;

  products?.forEach((prd) => {
    if (selectedProductIds.includes(prd.id)) {
      let prdGross = Number(prd.grossWeight);
      const prdUnit = prd.measurementUnit;

      if (prdUnit === 'metric' && pkgUnit === 'imperial') {
        prdGross *= KgsToLbs;
      } else if (prdUnit === 'imperial' && pkgUnit === 'metric') {
        prdGross *= LbsToKgs;
      }

      grossWtSum += prdGross;
    }
  });

  return Number(grossWeight) <= grossWtSum;
};
